import { AuthError } from "@azure/msal-browser";
import _ from "lodash";

export const isError = (exception: any): exception is Error => {
    return exception instanceof Error ? true : false;
}

export const isAuthError = (exception: any): exception is AuthError => {
    return typeof exception == 'object'
        && exception !== null
        && 'name' in exception && exception.name === 'AuthError'
        && 'errorMessage' in exception && typeof exception.errorMessage === 'string'
        && 'errorCode' in exception && typeof exception.errorCode === 'string';
}

export class BackendValidationError extends Error {

    public readonly validationErrors: BackendValidationErrorDetail[];
    public readonly json: string;

    constructor(validationErrors: BackendValidationErrorDetail[], json: string, msg?: string) {
        super(msg);

        this.validationErrors = validationErrors;
        this.json = json;
    }

}

export function isBackendValidationError(obj: any): obj is BackendValidationError {
    const castObj = obj as BackendValidationError;
    const isError = _.isError(castObj);
    const hasValidationErrors = _.isArray(castObj.validationErrors);
    const hasJson = _.isString(castObj.json);
    return isError && hasValidationErrors && hasJson;
}

export type BackendValidationErrorDetail = {
    loc: (string | number)[];
    msg: string;
    type: string;
    ctx: any;
};

export const LOC_VALUE_BODY = 'body';

export function isBackendValidationErrorDetail(obj: any): obj is BackendValidationErrorDetail {
    const castObj = obj as BackendValidationErrorDetail;
    return _.isArray(castObj.loc) && _.isString(castObj.msg) && _.isString(castObj.type);// && castObj.ctx !== undefined;
}

export async function convertResponseToError(responseData: any, originalJson: string, message?: string): Promise<BackendValidationError | Error> {
    if (_.has(responseData, 'detail') && _.isArray(responseData.detail)) {
        const errors: BackendValidationErrorDetail[] = (responseData.detail.map((d: any) => isBackendValidationErrorDetail(d) ? d as BackendValidationErrorDetail : undefined))
            .filter((e: BackendValidationErrorDetail | undefined) => e !== undefined);
        if (errors.length > 0) {
            return new BackendValidationError(errors, originalJson, message);
        }
    }
    return new Error(message);
}
